import Hero from "@/components/home/Hero";
import BrandMarquee from "@/components/home/BrandMarquee";
import Ecosystem from "@/components/home/Ecosystem";
import NetworkGrid from "@/components/home/NetworkGrid";
import VideoStrip from "@/components/home/VideoStrip";
import Solutions from "@/components/home/Solutions";
import Manifesto from "@/components/home/Manifesto";
import Numbers from "@/components/home/Numbers";
import SEO from "@/components/shared/SEO";
import { useLang } from "@/i18n/LanguageContext";

export default function HomePage() {
  const { t } = useLang();
  return (
    <main data-testid="home-page">
      <SEO title={t.seo.home.title} description={t.seo.home.desc} path="/" />
      <Hero />
      <BrandMarquee />
      <Ecosystem />
      <NetworkGrid />
      <VideoStrip />
      <Solutions />
      <Manifesto />
      <Numbers />
    </main>
  );
}
